module.exports = __webpack_public_path__ + "static/legacy_card_img3@2x-2e11ec33e2d548907eca4215084892ff.png";